<div class="row">
    <div class="col-sm-12 col-12">
        <h1>Análise do Aditivo da PAC<span *ngIf="aditivo"> {{aditivo?.propostaNumero}}
            / {{aditivo?.propostaAno}}</span>
        </h1>
    </div>
</div>

<div *ngIf="!podeAditar" class="alert alert-danger">
    <p>A operação relacionada a este aditivo não está ativa, logo não pode ser aditada.</p>
</div>

<h5>Dados Gerais</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <!-- div class="col-sm-2 col-12">
                <h6 class="mb-0">PAC Aditada</h6>
                <p>{{aditivo?.idPacAditada}}</p>
            </div -->
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Proposta / Ano</h6>
                <p>{{aditivo?.propostaNumero}} / {{aditivo?.propostaAno}}</p>
            </div>
            <div class="col-sm-6 col-12">
                <h6 class="mb-0">Programa / Linha</h6>
                <p title="Programa-Linha: {{pacOriginal?.programaId | number:'3.0-0'}}-{{pacOriginal?.linhaId | number:'3.0-0'}}">
                    {{pacOriginal?.programaNome}} / {{pacOriginal?.linhaNome}}
                </p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Fase (Situação)</h6>
                <p title="{{aditivo?.situacaoId}} - {{aditivo?.situacaoNomeInterno}}">
                    {{aditivo?.situacaoFase}}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Número PAC</h6>
                <p>{{aditivo?.numeroPac | number:'6.0' | bnMask:'00.000-0'}}</p>
            </div>
            <div class="col-sm-6 col-12">
                <h6 class="mb-0">Documento N03</h6>
                <p>{{operacaoN03}}</p>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Protocolo Aditivo</h6>
                <p>{{aditivo?.datProtocolo | date: 'dd/MM/yyyy'}}</p>
            </div>
        </div>
    </div>
</div>

<h5>Dados da Beneficiária</h5>
<div class="card">
    <div class="card-body">

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ / CPF</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorCnpjCpf}}"
                    valorDepois="{{aditivo?.compradorCnpjCpf}}"
                    valorExibicaoAntes="{{pacOriginal?.compradorCnpjCpf | bnMask: 'CNPJCPF'}}"
                    valorExibicaoDepois="{{aditivo?.compradorCnpjCpf | bnMask: 'CNPJCPF'}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Razão Social</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorNome}}"
                    valorDepois="{{aditivo?.compradorNome}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorCnae}}"
                    valorDepois="{{aditivo?.compradorCnae}}"
                    valorExibicaoAntes="{{pacOriginal?.compradorCnaeIdNome}}"
                    valorExibicaoDepois="{{aditivo?.compradorCnaeIdNome}}"
                ></detalhe-diferenca>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">ROB Beneficiária</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorRobValor}}"
                    valorDepois="{{aditivo?.compradorRobValor}}"
                    valorExibicaoAntes="{{pacOriginal?.compradorRobValor | bnMask: 'MOEDA'}}"
                    valorExibicaoDepois="{{aditivo?.compradorRobValor | bnMask: 'MOEDA'}}"
                ></detalhe-diferenca>
                <!-- small>{{aditivo?.compradorRobValor || pacOriginal?.compradorRobValor | valorPorExtenso : 'monetario' : 'BRL'}}</small -->

            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorRobData}}"
                    valorDepois="{{aditivo?.compradorRobData}}"
                    valorExibicaoAntes="{{pacOriginal?.compradorRobData | date: 'dd/MM/yyyy'}}"
                    valorExibicaoDepois="{{aditivo?.compradorRobData | date: 'dd/MM/yyyy'}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Tipo de Renda</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorRobTipoNome}}"
                    valorDepois="{{aditivo?.compradorRobTipoNome}}"
                ></detalhe-diferenca>
            </div>
        </div>

        <div *ngIf="aditivo?.grupoCnpjLider && aditivo?.grupoRobTipo">
            <div class="row" *ngIf="aditivo?.grupoRobTipo">

                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">ROB do Grupo Econômico</h6>
                    <detalhe-diferenca
                        valorAntes="{{pacOriginal?.grupoRobValor}}"
                        valorDepois="{{aditivo?.grupoRobValor}}"
                        valorExibicaoAntes="{{pacOriginal?.grupoRobValor | bnMask: 'MOEDA'}}"
                        valorExibicaoDepois="{{aditivo?.grupoRobValor | bnMask: 'MOEDA'}}"
                    ></detalhe-diferenca>
                    <!-- small>{{aditivo?.grupoRobValor | valorPorExtenso : 'monetario' : 'BRL'}}</small -->
                </div>
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">Data de Referência</h6>
                    <detalhe-diferenca
                        valorAntes="{{pacOriginal?.grupoRobData}}"
                        valorDepois="{{aditivo?.grupoRobData}}"
                        valorExibicaoAntes="{{pacOriginal?.grupoRobData | date: 'dd/MM/yyyy'}}"
                        valorExibicaoDepois="{{aditivo?.grupoRobData | date: 'dd/MM/yyyy'}}"
                    ></detalhe-diferenca>
                </div>
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">Tipo de Renda</h6>
                    <detalhe-diferenca
                        valorAntes="{{pacOriginal?.grupoRobTipoNome}}"
                        valorDepois="{{aditivo?.grupoRobTipoNome}}"
                    ></detalhe-diferenca>
                </div>
            </div>
            <div class="row" *ngIf="aditivo?.grupoCnpjLider">
                <div class="col-sm-4 col-12">
                    <h6 class="mb-0">CNPJ Líder Grupo</h6>
                    <detalhe-diferenca
                        valorAntes="{{pacOriginal?.grupoCnpjLider}}"
                        valorDepois="{{aditivo?.grupoCnpjLider}}"
                        valorExibicaoAntes="{{pacOriginal?.grupoCnpjLider | bnMask: 'CNPJ'}}"
                        valorExibicaoDepois="{{aditivo?.grupoCnpjLider | bnMask: 'CNPJ'}}"
                    ></detalhe-diferenca>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-12">
                <h6 class="mb-0">Porte</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorPorteNome}}"
                    valorDepois="{{aditivo?.compradorPorteNome}}"
                ></detalhe-diferenca>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">Caracterização do Capital Social</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorCapitalSocialNome}}"
                    valorDepois="{{aditivo?.compradorCapitalSocialNome}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Atividade Decreto 2.333/1997</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.compradorIndAtividadeDecreto}}"
                    valorDepois="{{aditivo?.compradorIndAtividadeDecreto}}"
                ></detalhe-diferenca>
            </div>
        </div>
    </div>
</div>

<h5>Dados do Investimento</h5>
<div class="card">
    <div class="card-body">

        <div class="row">
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNPJ Investimento</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.investimentoCnpj}}"
                    valorDepois="{{aditivo?.investimentoCnpj}}"
                    valorExibicaoAntes="{{pacOriginal?.investimentoCnpj | bnMask: 'CNPJ'}}"
                    valorExibicaoDepois="{{aditivo?.investimentoCnpj | bnMask: 'CNPJ'}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">CNAE Investimento</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.investimentoCnae}}"
                    valorDepois="{{aditivo?.investimentoCnae}}"
                    valorExibicaoAntes="{{pacOriginal?.investimentoCnaeIdNome}}"
                    valorExibicaoDepois="{{aditivo?.investimentoCnaeIdNome}}"
                ></detalhe-diferenca>
            </div>
            <div class="col-sm-4 col-12">
                <h6 class="mb-0">Município de Instalação</h6>
                <detalhe-diferenca
                    valorAntes="{{pacOriginal?.municipioInstalId}}"
                    valorDepois="{{aditivo?.municipioInstalId}}"
                    valorExibicaoAntes="{{pacOriginal?.municipioInstalNomeUf}}"
                    valorExibicaoDepois="{{aditivo?.municipioInstalNomeUf}}"
                ></detalhe-diferenca>
            </div>
        </div>
    </div>
</div>

<h5>Comentário do Aditivo</h5>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <p>{{aditivo?.comentario}}</p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="resultadoConsultaErros?.erros?.length > 0" class="alert alert-warning">
    <h5 class="alert alert-warning">Erros durante o envio deste aditivo.</h5>
    <ul>
        <li *ngFor="let e of resultadoConsultaErros?.erros">{{e.msg}}</li>
    </ul>
</div>



<hr/>
<hr/>
<hr/>
<h5>Análise e Aprovação</h5>

<span *ngIf="avisosFluxoAprovacao?.length">
  <h6>Avisos Fluxo Aprovação</h6>

  <div class="clickable" (click)="onAlternarVisualizacaoAvisos()">
    <div class="card">
      <div class="card-body">


        <span *ngIf="exibeTodosAvisosFluxoAprovacao">
          <span *ngFor="let aviso of avisosFluxoAprovacao">
            <div class="row">
              <div class="col-sm-3 col-6">{{aviso?.data | date:'dd/MM/yyyy HH:mm'}}</div>
              <div class="col-sm-3 col-6"><b>{{aviso?.usuario}}</b></div>
              <div class="col-sm-6 col-12"><small>({{aviso?.nomeTipoAviso}})</small></div>
            </div>
            <div class="row">
              <div class="col-12">{{aviso?.mensagem}}</div>
            </div>
          </span>
          <small class="float-end">Clique para ver menos...</small>
        </span>

        <span *ngIf="!exibeTodosAvisosFluxoAprovacao">
          <span>
            <div class="row">
              <div class="col-sm-3 col-6">{{avisosFluxoAprovacao[0]?.data | date:'dd/MM/yyyy HH:mm'}}</div>
              <div class="col-sm-3 col-6"><b>{{avisosFluxoAprovacao[0]?.usuario}}</b></div>
              <div class="col-sm-6 col-12"><small>({{avisosFluxoAprovacao[0]?.nomeTipoAviso}})</small></div>
            </div>
            <div class="row">
              <div class="col-12">{{avisosFluxoAprovacao[0]?.mensagem}}</div>
            </div>
          </span>
          <small class="float-end">Clique para ver mais...</small>
        </span>
      </div>
    </div>
  </div>
  <p> </p>
</span>


<span *ngIf="aditivo?.motivoDevolucao || ehFaseAnaliseAditivoEUsuarioEhAnalista()">
  <h6>Motivo da Devolução</h6>
  <div class="card" *ngIf="!ehFaseAnaliseAditivoEUsuarioEhAnalista()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <p>{{aditivo?.motivoDevolucao}}</p>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="ehFaseAnaliseAditivoEUsuarioEhAnalista()">
    <textarea class="col-12" [(ngModel)]="motivoDevolucao" autosize rows="4"
              [placeholder]="'Em caso de rejeição, informar o motivo para devolução do aditivo. Esta informação estará disponível para o agente financeiro.'"></textarea>
  </span>
</span>

<div class="row" *ngIf="ehFaseEUsuarioAprovador()">
    <div class="col-12">
        <h6 class="mb-0">Comentário sobre Análise</h6>
        <textarea class="col-12" [(ngModel)]="comentario" autosize rows="4"
                  [placeholder]="'Informação complementar da análise, de uso interno...'"></textarea>
    </div>
</div>

<div *ngIf="resultadoValidacaoAditivo?.erros?.length > 0" class="alert alert-danger">
    <h5 class="alert alert-danger"><i class="fa fa-exclamation-triangle me-1 error" aria-hidden="true"></i>Foram
        encontrados erros na validação deste aditivo.</h5>
    <p>Favor verificar os erros abaixo.</p>
    <ul>
        <li *ngFor="let e of resultadoValidacaoAditivo?.erros">{{e.msg}}</li>
    </ul>
</div>

<span *ngIf="aditivo?.ressalvasDeAprovacao">
    <h6>Ressalvas na Aprovação</h6>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-12" style="white-space: pre-line">
                    <p>{{aditivo?.ressalvasDeAprovacao}}</p>
                </div>
            </div>
        </div>
    </div>
</span>

<div *ngIf="!podeAditar" class="alert alert-danger">
    <p>A operação relacionada a este aditivo não está ativa, logo não pode ser aditada.</p>
</div>

<span *ngIf="ehFaseAnaliseAditivoEUsuarioEhAnalista()">
    <button class="btn btn-success" (click)="analistaAprovarAditivo()" *ngIf="!contemErrosValidacao()" [disabled]="!podeAprovarAditivo()">
        <i class="fa fa-thumbs-o-up me-1" aria-hidden="true"></i>
        Aprovar Aditivo
    </button>
    <button class="btn btn-success" (click)="analistaAprovarAditivoComRessalvas()" *ngIf="contemErrosValidacao()" [disabled]="!podeAprovarAditivo()">
        <i class="fa fa-thumbs-up me-1" aria-hidden="true"></i>
        Aprovar Aditivo Com Ressalvas
    </button>
    <button class="btn btn-warning" (click)="analistaRejeitarAditivo()">
        <i class="fa fa-thumbs-o-down me-1" aria-hidden="true"></i>
        Rejeitar Aditivo
    </button>
</span>

<span *ngIf="ehFaseAprovacaoGerenteEUsuarioEhGerente()">
    <span *ngIf="aditivo?.situacaoId != 3320"><!-- 3320=Em Análise pelo Gerente|Aditivo Rejeitado -->
        <button class="btn btn-success" (click)="gerenteAprovarAditivo()" [disabled]="!podeAprovarAditivo()">
            <i class="fa fa-thumbs-o-up me-1" aria-hidden="true"></i>
            Aprovar Aditivo
        </button>
    </span>
    <span *ngIf="aditivo?.situacaoId == 3320"><!-- 3320=Em Análise pelo Gerente|Aditivo Rejeitado -->
        <button class="btn btn-warning" (click)="gerenteRejeitarAditivo()">
            <i class="fa fa-thumbs-o-down me-1" aria-hidden="true"></i>
            Rejeitar Aditivo
        </button>
    </span>
    <button class="btn btn-secondary" (click)="gerenteReencaminharAditivo()">
        <i class="fa fa-arrow-circle-o-left me-1" aria-hidden="true"></i>
        Reencaminhar Aditivo
    </button>
</span>

<span *ngIf="ehFaseAprovacaoChefeEUsuarioEhChefe()">
    <button class="btn btn-success" (click)="chefeAprovarAditivo()" [disabled]="!podeAprovarAditivo()">
        <i class="fa fa-thumbs-o-up me-1" aria-hidden="true"></i>
        Aprovar Aditivo
    </button>
    <button class="btn btn-secondary" (click)="chefeReencaminharAditivo()">
        <i class="fa fa-arrow-circle-o-left me-1" aria-hidden="true"></i>
        Reencaminhar Aditivo
    </button>
</span>

<!-- Parecer da Análise -->

<!--
<hr/>
<hr/>
<hr/>
<hr/>
Aditivo: {{aditivo | json}}
<hr/>
PAC: {{pacOriginal | json}}

Avisos Fluxo Aprovacao: {{this.avisosFluxoAprovacao | json}}
-->
